import {KitEvent} from "@/Fwk/Kit/Track/KitEvent";
import Util from "@/Master/Util";

// SdkTrack 类用于处理和提交跟踪事件
export default class SdkTrack {
    static tag = '[SdkTrack]';
    static track513Commit(name: string, value1?: string, value2?: string, keyValues?:Map<string, string>) {
        const kitEvent = KitEvent.track513(name);
        if (value1) kitEvent.Put1(value1);
        if (value2) kitEvent.Put2(value2);
        if (keyValues) kitEvent.PutMap(keyValues);
        kitEvent.Commit();
    }

    static track512Commit(name: string, value1?: string, value2?: string, keyValues?:Map<string, string>) {
        const kitEvent = KitEvent.track512(name);
        if (value1) kitEvent.Put1(value1);
        if (value2) kitEvent.Put2(value2);
        if (keyValues) kitEvent.PutMap(keyValues);
        kitEvent.Commit();
    }

    static gameTrackCommit(src: number, track: string, jsonStr: string) {
        if (Util.isLog){
            console.log(this.tag,'src='+src,`track=`+track,`jsonStr=`+jsonStr);
        }
        let jsonData:Record<string, string> = {};
        try {
            jsonData = jsonStr && JSON.parse(jsonStr);
        } catch (e) {
            if (Util.isLog){
                console.error(this.tag, '埋点json解析错误', e);
            }
        }
        let keyValues:Map<string, string> = new Map<string, string>;
        Object.keys(jsonData).forEach((key) => {
            keyValues.set(key,jsonData[key]);
        });
        switch (src) {
            case 512:
                this.track512Commit(track, '', '', keyValues);
                break;
            case 513:
                this.track513Commit(track, '', '', keyValues);
                break;
        }
    }

}
